import {isNil} from 'lodash';
import React, {ChangeEvent, ReactElement, useRef} from 'react';
import {logMissingOnChange} from '../inputError';
import {Nil} from '../model/SharedTypes';
import NxGenericTextField from '../nxGenericTextField/NxGenericTextField';

export interface NxTextareaProps {
  className?: string;
  disabled?: boolean;
  error?: string;
  id?: string;
  label: React.ReactNode;
  name?: string;
  onBlur?: (e: ChangeEvent) => void;
  onChange?: (e: ChangeEvent) => void;
  positionAbsoluteError?: boolean;
  rows?: number;
  rowsMax?: number;
  required?: boolean;
  value?: string | null;
  maxLength?: number;
}

const calculateValue = (value: string | Nil, lastValue: string): string => {
  if (isNil(value)) {
    return value === null ? lastValue : '';
  }

  return value;
}

const NxTextarea = (
  {
    className,
    disabled = false,
    error,
    id,
    label,
    name,
    onBlur,
    onChange,
    positionAbsoluteError,
    required,
    rows,
    rowsMax,
    value,
    maxLength
  }: NxTextareaProps
): ReactElement => {

  const lastValue = useRef('');
  const finalValue = calculateValue(value, lastValue.current);
  lastValue.current = finalValue;

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    lastValue.current = event.target.value;
    if (!onChange) {
      logMissingOnChange('Textarea', name);
      return;
    }

    onChange(event);
  };

  return <NxGenericTextField className={className}
                             disabled={disabled}
                             error={error}
                             id={id}
                             onBlur={onBlur}
                             onChange={handleChange}
                             positionAbsoluteError={positionAbsoluteError}
                             required={required}
                             label={label}
                             multiline
                             name={name}
                             rows={rows}
                             rowsMax={rowsMax}
                             value={finalValue}
                             inputProps={{maxLength:maxLength}}/>
}

export default NxTextarea;
